import WebApiService from "@/services/webapi.service.js";
import StatoIntervento from "@/models/statoIntervento.model.js";

const state = {
    statiIntervento: []
}

const getters = {

    getStatiIntervento: (state) => {
        return state.statiIntervento;
    },
    getDescrizioneStato: (state) => (codice) => {

        if(!state.statiIntervento){
            return "";
        }    

        let stato = state.statiIntervento.find(item => { return item.Codice === codice });

        if(!stato){
            return "";
        }

        return stato.Descrizione;    

    }
}

const mutations = {

    setStatiIntervento: (state, statiIntervento) => {
        state.statiIntervento = statiIntervento;      
    }
}

const actions = {

    getStatiIntervento: ({commit}, data) => {                                                                                                              
        return WebApiService.get('interventi/GetStatiIntervento', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setStatiIntervento", data.Data.map(
                        o => { return Object.assign(new StatoIntervento(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}